import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "flowbite-react";
import { getAllBanner } from "../../Store/Action";
import { useMediaQuery } from "react-responsive";
import clsx from "clsx";
import { useThemeClass } from "@/Hooks/useThemeClass";
import addScrollParam from "@/utils/addScrollParam.ts";

const S3_URL = import.meta.env.VITE_S3_URL;

// function ItemBanner({ src }) {
//   return (
//     <div className="px-4 py-2">
//       <img
//         src={`${S3_URL}${src}`}
//         className="w-full object-cover aspect-video rounded-2xl"
//         alt="배너"
//       />
//     </div>
//   );
// }

function HBannerCarousel() {
  const themeClass = useThemeClass();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const dataBanner = useSelector(
    (state) => state.ReducerAllBanner.allBannerData?.data || []
  );
  console.log(dataBanner);
  
  // tailwind에서 lg 기준은 보통 1024px부터 시작하므로, 그보다 작은 경우를 모바일로 가정합니다.
  // xl 기준은 보통 1280px부터 시작하므로, 그보다 작은 경우를 모바일로 가정합니다.
  const isMobile = useMediaQuery({ query: "(max-width: 1023px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 1280px)" });
  const centerSlidePercentage = isMobile ? 100 : isTablet ? 70 : 50;

  useEffect(() => {
    dispatch(getAllBanner());
  }, [dispatch]);

  return (
    <div className="w-full">
      <div
        className={clsx(
          themeClass.bg("home"),
          `absolute inset-0 w-screen h-[20%] left-1/2 -translate-x-1/2 -z-10 rounded-2xl`
        )}
      />
      {dataBanner.length === 0 ? (
        <div className="w-full h-full flex justify-center items-center">
          <Spinner className="w-10 h-10 animate-spin" />
        </div>
      ) : (
        <Carousel
          showArrows={false}
          autoPlay={true}
          infiniteLoop={true}
          interval={3000}
          transitionTime={500}
          showStatus={false}
          showThumbs={false}
          centerMode={true}
          centerSlidePercentage={centerSlidePercentage}
        >
          {dataBanner.map((el) => {
            const handleClick = (e) => {
              e.preventDefault();

              // 링크가 없으면 아무것도 하지 않음
              if (!el.link) return;
              
              try {
                // 절대 URL인지 확인
                if (el.link.startsWith('http://') || el.link.startsWith('https://')) {
                  const linkUrl = new URL(el.link);
                  const currentUrl = new URL(window.location.href);
                  
                  // 같은 도메인인지 확인
                  if (linkUrl.hostname === currentUrl.hostname) {
                    // 같은 도메인이면 React Router로 이동
                    if(linkUrl.pathname === '/'){
                      navigate(addScrollParam(linkUrl.pathname + linkUrl.search, "recent"));
                    } else {
                      navigate(linkUrl.pathname + linkUrl.search);
                    }
                  } else {
                    // 다른 도메인이면 새 탭에서 열기
                    window.open(el.link, '_blank');
                  }
                } else {
                  // 상대 경로면 React Router로 이동
                  navigate(el.link);
                }
              } catch (error) {
                console.error('Invalid URL:', el.link);
                // URL 파싱 실패 시 React Router로 시도
                navigate(el.link);
              }
            };
            
            return (
              <div 
                key={el.id}
                onClick={handleClick}
                className="cursor-pointer"
              >
                <div className="px-4 py-2">
                  <img
                    src={`${S3_URL}${el.image}`}
                    className="w-full object-cover aspect-video rounded-2xl"
                    alt="배너"
                  />
                </div>
              </div>
            );
          })}
        </Carousel>
      )}
    </div>
  );
}

export default HBannerCarousel;
